import ByWeatherGrid from "./ByWeatherGrid";
const BaseCard: React.FC<any> = ({ itemList, style = {}, useTransparentStyle = false }) => {
  return <ByWeatherGrid style={style} itemList={itemList} useTransparentStyle={useTransparentStyle} />;
};

export default BaseCard;
